(function () {
  function initCravingProducts(section) {
    if (!section || typeof Swiper === "undefined") {
      return;
    }

    const slider = section.querySelector(".blj-craving-products__swiper");
    if (!slider || slider.dataset.initialized === "true") {
      return;
    }

    slider.dataset.initialized = "true";

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 12,
      speed: 500,
      pagination: {
        el: section.querySelector(".blj-craving-products__pagination"),
        clickable: true
      },
      navigation: {
        nextEl: section.querySelector(".blj-craving-products__arrow--next"),
        prevEl: section.querySelector(".blj-craving-products__arrow--prev")
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        990: {
          slidesPerView: Number(section.dataset.desktopSlides || 3),
          spaceBetween: 24
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll("[data-craving-products-section]").forEach(initCravingProducts);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function (event) {
    initCravingProducts(event.target);
  });
})();
